import { useEffect, useState } from 'react';

const useContentIndex = ({ includeUnlisted = false } = {}) => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;
    const load = async () => {
      try {
        const response = await fetch('/content/index.json', { cache: 'no-store' });
        if (!response.ok) throw new Error(`Content index returned ${response.status}`);
        const data = await response.json();
        if (mounted) setItems(Array.isArray(data) ? data.filter(item => includeUnlisted || !item.unlisted) : []);
      } catch {
        if (mounted) setItems([]);
      } finally {
        if (mounted) setLoading(false);
      }
    };
    load();
    return () => { mounted = false; };
  }, [includeUnlisted]);

  return { items, loading };
};

export default useContentIndex;
